import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Employee, EmployeeCreate, EmployeeFilter } from '../data/employee';

export function createEmployeeService(client: AxiosInstance) {
  return createCrudService<Employee, EmployeeCreate, EmployeeFilter>(client, "/hrm/Employee", "employeeId");
}

export type EmployeeService = CrudService<Employee, EmployeeCreate, EmployeeFilter>;
